
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import publishedVersions from '../versions.json';
import { version } from '../package.json';
export const filteredPublishedVersions = publishedVersions.filter(version => {
  if (version.includes('canary')) {
    return false;
  }

  return true;
}).reverse() // Remove the first 19 versions as they did not include docz when published.
.slice(0, -19);

const layoutProps = {
  filteredPublishedVersions
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "design-system-versions"
    }}>{`Design System Versions`}</h1>


    <div style={{
      "backgroundColor": '#F5F6F7',
      "padding": '15px'
    }}>
  <a href={`https://design-system.economist.com/docs/latest/index.html`} target="_blank">
    <strong>Latest version</strong>
  </a>
  <ul>
    {filteredPublishedVersions.map((version, index) => <li key={index}>
        <a href={`https://design-system.economist.com/docs/${version}/index.html`} target="_blank">
          {version}
        </a>
      </li>)}
  </ul>
    </div>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;